// transforms the data returned by strapi into an array
export const extractStrapiCarouselItems = (carousel: any) => {
  if (!carousel?.length) {
    return [];
  }
  return carousel
    .map((item: any) => {
      const { __typename, event } = item;
      const { title, hero_ad } = event;
      switch (__typename) {
        case 'allStrapi_ComponentCarouselTitleSlide':
          return title?.published
            ? { ...title, __typename, fromStrapi: true }
            : null;
        case 'allStrapi_ComponentCarouselFeaturedEvent':
          return event?.published
            ? { ...event, __typename, fromStrapi: true }
            : null;
        case 'allStrapi_ComponentCarouselAdSlide':
          return hero_ad ? { ...hero_ad, __typename, fromStrapi: true } : null;
        default:
          return null;
      }
    })
    .filter((item) => item); // filter out null values
};
